export default __webpack_public_path__ + "static/PureCircle-cfcea74b6d9183a75e18abecaaf33d97.png";